<template>
  <!--头组件-->
  <div class="header-com position-fixed w-100 p-0" @mouseleave="state.curMouseEnterPage = null">
      <nav class="navbar navbar-expand-lg navbar-dark">
        <div class="container-fluid">
          <router-link class="navbar-brand p-0" to="/PhotoSir">
            <img src="../assets/images/header/image_logo.jpg" alt="img-logo" class="home-logo">
          </router-link>
          <div v-if="state.menuCollapse" style="flex: 1;"></div>
          <div class="navbar-toggler border-0 m-0 p-0" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" :aria-expanded="state.menuCollapse"
               aria-label="Toggle navigation">
            <div class="d-flex flex-row">
              <button v-if="!state.userInfoGlobal.isLogin" type="button" class="btn btn-outline-dark text-white border-primary" style="background-color: #257CFF;" @click="loginClick">
                登录/注册
              </button>
              <el-dropdown popper-class="cus-header-popper" v-if="state.userInfoGlobal.isLogin" trigger="click">
                <span class="d-flex flex-row align-items-center">
                  <img style="width: 30px;height: 30px;border-radius: 50%;" :src="state.userInfoGlobal.headimgurl" alt="img-header">
                  <span class="ms-1 d-inline-block text-truncate fs-07" style="color: rgb(201, 201, 201);max-width: 100px;">
                    {{state.userInfoGlobal.nickname }}
                  </span>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item>
                      <div class="w-100 d-flex flex-column">
                        <div class="d-flex flex-row align-items-center">
                          <img class="img-header" :src="state.userInfoGlobal.headimgurl" alt="img-header">
                          <span class="mx-2 w-100 text-truncate text-end" style="max-width: 100%;">
                            {{state.userInfoGlobal.nickname }}
                          </span>
                          <img v-if="state.userInfoGlobal.isBvip" class="img-vip-icon" src="../assets/images/header/icon_bvip.png" alt="img-bvip">
                          <img v-if="state.userInfoGlobal.isSvip" class="img-vip-icon" src="../assets/images/header/icon_svip.png" alt="img-svip">
                          <img v-if="state.userInfoGlobal.isSSvip" class="img-vip-icon" src="../assets/images/header/icon_ssvip.png" alt="img-ssvip">
                        </div>
                        <div v-if="!state.userInfoGlobal.isSvip && !state.userInfoGlobal.isSSvip && !state.userInfoGlobal.isBvip" class="w-100 my-2 p-3 lh-lg rounded-2 text-wrap"
                             style="background-color: #F1F1F1;">
                          <div style="color: #3D3D3D;" class="fs-07">
                            开通会员
                          </div>
                          <div style="color: #555353;" class="fs-07">
                            开通会员畅享海量素材，一站式通用会员可支持-悟空图像pc端、悟空工具箱、悟空图像app，大量精选等你来。
                          </div>
                        </div>
                        <div v-if="state.userInfoGlobal.isSvip || state.userInfoGlobal.isSSvip || state.userInfoGlobal.isBvip" class="w-100 my-2 p-3 lh-lg rounded-2 text-wrap fs-07"
                             style="background-color: #eccda4;color: #555353;">
                          悟空会员畅享海量素材，一站式通用会员可支持-悟空图像pc端、悟空工具箱、悟空图像app，大量精选等你来。
                        </div>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <a class="w-100 el-link text-center" :href="state.userCenterUrl" target="_blank">
                        用户中心
                      </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="w-100 text-center" @click="logoutClick">退出登录</div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <button type="button" class="btn bg-transparent" @click="menuClick(state.menuCollapse)">
                <span class="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
          <div id="navbarSupportedContent" v-show="state.navbarSupported" class="collapse navbar-collapse" :class="state.menuCollapse?'mb-2':''">
            <ul class="navbar-nav flex-fill">
              <li class="nav-item px-sm-1 px-md-1 px-lg-1 px-xl-1 px-xxl-0" style="flex: 1;" v-for="(page,index) in state.pageList" :key="index" :class="page.children.length === 0?'':'dropdown'">
                <router-link v-if="page.children.length === 0" class="nav-link" :class="state.curPage.name === page.name?'active':''" aria-current="page" :to="page.path"
                             @mouseenter="state.curMouseEnterPage = page" @click="dropdownClick(page)">
                  {{ page.name }}
                </router-link>
                <div v-if="page.children.length > 0">
                  <div :id="'dropdown-'+index" class="nav-link dropdown-toggle"
                       :class="(state.curMouseEnterPage && state.curMouseEnterPage.name === page.name) || itemActive(index, state.curPage.name)?'active show':''" role="button"
                       data-bs-toggle="dropdown" :aria-expanded="(state.curMouseEnterPage && state.curMouseEnterPage.name === page.name) || state.curPage.name === page.name"
                       @mouseenter="state.curMouseEnterPage = page">
                       <!-- @click="dropdownClick(page)" -->
                    {{ page.name }}
                  </div>
                  <ul class="dropdown-menu dropdown-menu-bg" :class="(state.curMouseEnterPage && state.curMouseEnterPage.name === page.name) || state.curPage.name === page.name?'show':''"
                      :aria-labelledby="'dropdown-'+index">
                    <div v-if="!state.menuCollapse && index === 0">
                       <li class="dropdown-item">
                        <div class="list-group dropdown-list">
                          <router-link class="list-group-item m-sm-1" v-for="(child,childIndex) in page.children" :key="childIndex" :to="child.path" @click="dropdownClick(child)">
                            <div class="item-cover">
                              <img :src="child.icon" alt="img-icon" style="max-width: 100%;max-height: 100%;">
                            </div>
                            <p class="item-title">{{ child.name }}</p>
                            <div class="item-desc">{{ child.desc }}</div>
                          </router-link>
                            <div class="list-group-item m-sm-1 cur" @click="lastPageClick(state.aigcUrl)">
                              <div class="item-cover">
                                <img src="../assets/images/header/aigc.png" alt="img-icon" style="max-width: 100%;max-height: 100%;">
                              </div>
                            <p class="item-title ">悟空AI</p>
                            <div class="item-desc">一键AI生图</div>
                          </div>
                        </div>
                      </li>
                    </div>
                    <div v-else>
                      <li v-for="(child,childIndex) in page.children" :key="childIndex">
                        <router-link class="dropdown-item" :to="child.path" @click="dropdownClick(child)">
                          <div class="d-grid gap-2">
                            <button type="button" class="btn btn-black">{{ child.name }}</button>
                          </div>
                        </router-link>
                      </li>
                    </div>
                    <div class="dropdown-item min-show">
                      <div class="d-grid gap-2" @click="lastPageClick(state.aigcUrl)" v-if="page.path === 'SeriesProducts'">
                        <button type="button" class="btn btn-black" style="width: 100%;margin:5px auto;">悟空AI</button>
                      </div>
                    </div>
                  </ul>
                </div>
              </li>
            </ul>
            <!-- <div class="d-flex align-items-center" :class="state.menuCollapse?'mb-2':''" style="flex: 1;min-width: max-content;">
              <div class="nav-link fs-6 text-white d-flex align-items-center position-relative btn-creative fw-bolder rounded-5" style="min-height: 2.8125rem;" @click="goToLen">
                <img src="https://cdn.photosir.cn/paramter/713554087093731328.gif" alt="" style="width: 50% !important;margin-top:10px;">
              </div>
            </div> -->
            <button v-if="!state.userInfoGlobal.isLogin" type="button" class="btn btn-outline-dark text-white border-primary" style="background-color: #257CFF;" @click="loginClick">
              登录/注册
            </button>
            <el-dropdown popper-class="cus-header-popper" v-if="state.userInfoGlobal.isLogin" trigger="click" :teleported="false">
              <span class="d-flex flex-row align-items-center">
                <img class="img-header" :src="state.userInfoGlobal.headimgurl" alt="img-header">
                <span class="ms-1 d-inline-block text-truncate fs-07" style="color: rgb(201, 201, 201);max-width: 140px;">
                  {{state.userInfoGlobal.nickname }}
                </span>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <div class="w-100 d-flex flex-column">
                      <div class="d-flex flex-row align-items-center">
                        <img class="img-header" :src="state.userInfoGlobal.headimgurl" alt="img-header">
                        <span class="mx-2 w-100 text-truncate text-end" style="max-width: 100%;">
                          {{state.userInfoGlobal.nickname }}
                        </span>
                        <img v-if="state.userInfoGlobal.isBvip" style="width: 40px;max-height: 40px;" src="../assets/images/header/icon_bvip.png" alt="img-bvip">
                        <img v-if="state.userInfoGlobal.isSvip" style="width: 40px;max-height: 40px;" src="../assets/images/header/icon_svip.png" alt="img-svip">
                        <img v-if="state.userInfoGlobal.isSSvip" style="width: 40px;max-height: 40px;" src="../assets/images/header/icon_ssvip.png" alt="img-ssvip">
                      </div>
                      <div v-if="!state.userInfoGlobal.isSvip && !state.userInfoGlobal.isSSvip && !state.userInfoGlobal.isBvip" class="w-100 my-2 p-3 lh-lg rounded-2 text-wrap"
                           style="background-color: #F1F1F1;">
                        <div style="color: #3D3D3D;" class="fs-07">
                          开通会员
                        </div>
                        <div style="color: #555353;" class="fs-07">
                          开通会员畅享海量素材，一站式通用会员可支持-悟空图像pc端、悟空工具箱、悟空图像app，大量精选等你来。
                        </div>
                      </div>
                      <div v-if="state.userInfoGlobal.isSvip || state.userInfoGlobal.isSSvip || state.userInfoGlobal.isBvip" class="w-100 my-2 p-3 lh-lg rounded-2 text-wrap fs-07"
                           style="background-color: #eccda4;color: #555353;">
                        悟空会员畅享海量素材，一站式通用会员可支持-悟空图像pc端、悟空工具箱、悟空图像app，大量精选等你来。
                      </div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <a class="w-100 el-link text-center" :href="state.userCenterUrl" target="_blank">
                      用户中心
                    </a>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="w-100 text-center" @click="logoutClick">退出登录</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </nav>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { defineProps, defineEmits, ref, inject, reactive, onMounted } from 'vue'
import userInfoService from '@/utils/userinfoservice'
const userInfoGlobal = ref(inject('$userInfoGlobal'))
/**
 * 接收父组件的传参
 */
defineProps(['isLogin'])

/**
 * 传参给父组件
 */
const emit = defineEmits(['loginClick', 'logoutClick'])

const route = useRoute()
const router = useRouter()

const state = reactive({
  aigcUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/home/galleryList', // aigc跳转地址
  navbarSupported: false,
  userInfoGlobal,
  userCenterUrl: window.SITE_CONFIG.websiteBaseUrl + '/#/front/Personal/PersonalInformation',
  menuCollapse: false,
  curPage: { path: '/PhotoSir', name: '悟空图像', icon: '', children: [] }, // 当前选中页面（默认值： PhotoSir 是首页）
  curMouseEnterPage: null,
  pageList: [
    // { path: '/PhotoSir', name: '悟空图像', icon: '', desc: '', children: [] },
    {
      path: 'SeriesProducts', name: '系列产品', icon: '', children: [
        { path: '/PhotoSirSoftware', name: '悟空图像', icon: require('../assets/images/header/image_photosir.png'), desc: '图好做，做好图', children: [] },
        { path: '/AiFlashDrawing', name: 'AI闪绘', icon: require('../assets/images/header/image_aish.png'), desc: '创意无需等待，1秒极速生成', children: [] },
        { path: '/Program', name: '悟空编程', icon: require('../assets/images/header/image_program.jpg'), desc: '0基础入门编程', children: [] },
        { path: '/Registering', name: '悟空套版', icon: require('../assets/images/header/image_registering.jpg'), desc: '不用一分钟就能搞定专业相册', children: [] },
        { path: '/LookPicture', name: '悟空看图', icon: require('../assets/images/header/image_look_picture.png'), desc: '看图更轻松', children: [] },
        { path: '/PhotoSplicing', name: '悟空拼图', icon: require('../assets/images/header/image_photo_splicing.jpg'), desc: '记录日常，享受拼图的乐趣', children: [] },
        { path: '/PhotoUpload', name: '悟空传图', icon: require('../assets/images/header/image_photo_upload.jpg'), desc: '高效、简单、跨平台传输', children: [] }
      ]
    },
    {
      path: 'MemberServices', name: '会员服务', icon: '', desc: '', children: [
        { path: '/Buy', name: '个人会员', icon: '', desc: '', children: [] },
        { path: '/GroupBuy', name: '企业会员', icon: '', desc: '', children: [] }
      ]
    },
    { path: '/CompanyNews', name: '企业资讯', icon: '', desc: '', children: [] },
    // {
    //   path: 'DownloadTutorial', name: '下载&教程', icon: '', desc: '', children: [
    //     { path: '/Download', name: '下载', icon: '', desc: '', children: [] },
    //     { path: '/VideoTutorial', name: '教程', icon: '', desc: '', children: [] }
    //   ]
    // },
    { path: '/Download', name: '下载中心', icon: '', desc: '', children: [] },
    { path: '/VideoTutorial', name: '在线教程', icon: '', desc: '', children: [] },
    { path: '/ContactView', name: '关于我们', icon: '', desc: '', children: [] },
    { path: '/ActivityCenter', name: '活动中心', icon: '', desc: '', children: [] }
  ] // 应用中所有页面集合
})


// * 跳转联想创意大赛
// const goToLen = () => {
//   // let routeData = router.resolve('/LenovoCompetition?token=' + userInfoService.getToken()) // 联想活动
//   let routeData = router.resolve('/AiHome?token=' + userInfoService.getToken()) // 年度海报大赛
//   window.open(routeData.href, '_blank')
// }
/**
 * nav-item的激活状态判断
 */
const itemActive = (index, name) => {
  return (index === 1 && (name === '系列产品' || name === '悟空编程' || name === '悟空套版' || name === '悟空看图' || name === '悟空拼图' || name === '悟空传图'))
    || (index === 2 && (name === '会员服务' || name === '个人会员' || name === '企业会员'))
    || (index === 4 && (name === '下载&教程' || name === '下载' || name === '教程'))
}

/**
 * 菜单按钮被点击
 */
const menuClick = (menuCollapse) => {
  state.menuCollapse = !menuCollapse
  state.curMouseEnterPage = null
  if (state.menuCollapse) {
    state.navbarSupported = true
  } else {
    state.navbarSupported = false
  }
}

/**
 * 下拉按钮被点击
 */
const dropdownClick = (page) => {
  state.curPage = page
  if (!page.children.length) {
    state.menuCollapse = state.navbarSupported = false
  }
}

const lastPageClick = (url) => {
  window.open(url, '_blank')
}

/**
 * 登录/注册按钮被点击
 */
const loginClick = () => {
  // state.isLogin = true
  console.log('登录/注册按钮被点击')
  emit('loginClick')
}

/**
 * 登出/退出登录按钮被点击
 */
const logoutClick = () => {
  // state.isLogin = false
  console.log('登出/退出登录按钮被点击')
  emit('logoutClick')
}
const getUserLogin = async () => {
  if (route.query.token) {
    userInfoService.setToken(route.query.token)
    const newQuery = { ...route.query }
    delete newQuery.token
    // 如果有其他查询参数，则替换当前路由的查询参数
    if (Object.keys(newQuery).length > 0) {
      await router.replace({ ...route, query: newQuery })
    } else {
      // 如果只有token，则清空当前路由的查询参数
      await router.replace({ path: route.path, query: {} })
    }
  } else {
    userInfoService.getUserData(state.userInfoGlobal)
  }
}

onMounted(() => {
  getUserLogin()
})
</script>

<style lang="scss" scoped>
  .min-show{
    display: none;
  }
  .navbar-nav .nav-link.show{
    color: #97989A;
  }
  .fs-07{
      font-size: 14PX !important;
    }
  .img-header{
    width: 40px;
    height: auto;
    min-width: 40PX;
    min-height: 40PX;
    border-radius: 50%;
  }
  .img-vip-icon{
    width: 40px;
    max-height: 40px;
  }
  .header-com {
    z-index: 1000;
    background-color: #181a1e;
    .navbar{
      width: 90%;
      padding: 0 !important;
      margin: 0 auto;
    }
    .nav-link:hover {
      color: #61aeff;
    }
    .dropdown-menu-bg {
      background-color: #202124;
      color: #ffffff;
    }
    .home-logo{
      width: 200px;
      padding: 0;
      min-width: 150PX;
    }

    .btn-creative {
      cursor: pointer;
      // background-image: url('../assets/images/header/image_header_gamebg.jpg');
      // background-repeat: no-repeat;
      // background-size: contain;
      // background-position: left top;
      // background: linear-gradient(#DD6F7A 0%, #9C2C51 100%) !important;
    }

    .dropdown-list {
      width: 800px !important;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .list-group-item {
        width: 190px;
        background-color: #000000;
        color: #ffffff;
        border-color: #000000;
        border-radius: 6px;
        .item-cover {
          width: 125px;
          height: 118px;
          margin: auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .item-title {
          font-size: 14px;
          color: #ffffff;
        }
        .item-desc {
          font-size: 12px;
          color: #9e9e9e;
        }
      }
      .list-group-item:hover {
        background-color: #101010;
        border-color: #101010;
      }
    }
    .dropdown-item {
      color: #ffffff;
      background-color: #202124;
    }
    .dropdown-item:hover {
      background-color: #202124;
    }
    .btn-black {
      background-color: #000000;
      color: #ffffff;
    }
    .btn-black:hover {
      background-color: #101010;
    }

    .btn-bg {
      background-image: url('../assets/images/header/image_header_gamebg.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;
    }
    @media (max-width: 992px) {
      .min-show{
        display: block;
      }
    }
    @media (max-width: 820px) {
      .navbar{
        width: 100% !important;
      }
      .navbar-collapse{
        padding: 0 0 20px 20px;
        top: 90px;
        left: 0;
        position: absolute;
        width: 100vw !important;
        z-index: 60;
        background-color: #181a1e !important;
      }
    }
    @media (max-width: 576px) {
      .navbar-collapse {
        top: 55px;
      }
    }
  }
</style>
<style lang="scss">
  .cus-header-popper {
    width: 500px;
  }
</style>
